import { enumProxy } from 'app/libs/helpers'

export default enumProxy({
  1: 'High',
  2: 'Medium',
  3: 'Low',
})
